import { render, staticRenderFns } from "./selectScrollFile.vue?vue&type=template&id=65f1acd7&scoped=true"
import script from "./selectScrollFile.vue?vue&type=script&lang=js"
export * from "./selectScrollFile.vue?vue&type=script&lang=js"
import style0 from "./selectScrollFile.vue?vue&type=style&index=0&id=65f1acd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1acd7",
  null
  
)

export default component.exports